import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Opt-in tones: the default stays on text.primary because this label is also
// imported by FarmerDbtVerification / RewampFormField, which are not part of
// the scheme-form colour re-spec.
const toneToken = (theme) => ({
  page: theme.palette.text.primary,
  form: theme.palette.formText.label,
  control: theme.palette.formText.checkbox,
});

export default function RewampFieldLabel({
  label,
  htmlFor,
  id,
  required = false,
  error = false,
  variant = "fieldLabel",
  tone = "page",
  sx,
  component = "label",
}) {
  const theme = useTheme();

  return (
    <Typography
      variant={variant}
      component={component}
      id={id}
      htmlFor={htmlFor}
      sx={{
        display: "block",
        color: error ? theme.palette.formMessage.error : toneToken(theme)[tone],
        ...sx,
      }}
    >
      {label}
      {required && (
        <Typography
          component="span"
          aria-hidden="true"
          sx={{ color: theme.palette.text.requiredMark, ml: 0.25, font: "inherit" }}
        >
          *
        </Typography>
      )}
    </Typography>
  );
}

RewampFieldLabel.propTypes = {
  label: PropTypes.node,
  htmlFor: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  variant: PropTypes.oneOf(["fieldLabel", "fieldLabelSmall"]),
  /** "form" = field label, "control" = checkbox/radio option text. */
  tone: PropTypes.oneOf(["page", "form", "control"]),
  sx: PropTypes.object,
  component: PropTypes.elementType,
};
